import * as Constants from "utils/Constants";
import React, { Component } from "react";
import Select, { components } from "react-select";
import {
  getClientList,
  getClientUserClaims,
  insertPortalAccessLog,
  updateClientID,
  updateIncludeCongloms,
  GetClient,
  getUser
} from "redux/actions/index";
import HelperFunctions from "utils/HelperFunctions";
import { connect } from "react-redux";
import { trackPromise } from "react-promise-tracker";
import { withRouter } from "utils/withRouter";
import GlobalSignalRManager from "components/SignalR/Signletons/GlobalSignalRManager";

class ClientDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedClient: null };
    this.previousClientId = null;
    
    const hubBaseUrl = import.meta.env.VITE_SIGNALR_URL;
    const emailHub = import.meta.env.VITE_EMAIL_HUB_NAME;
    const smsHub = import.meta.env.VITE_SMS_HUB_NAME;
    const processingItemHub = import.meta.env.VITE_PROCESSINGITEM_HUB_NAME;

    this.emailService = GlobalSignalRManager.getHub("email", hubBaseUrl + emailHub);
    this.smsService = GlobalSignalRManager.getHub("sms", hubBaseUrl + smsHub);
    this.processingItemService = GlobalSignalRManager.getHub("processingItem", hubBaseUrl + processingItemHub);
  }
  componentDidMount() {
    let includeCongloms = false;
    const location = window.location.pathname.toLowerCase();
    if (
      location === "/" ||
      location.includes(Constants.Route.DatabaseOverview) ||
      location.includes(Constants.Route.FileManagement) ||
      location.includes(Constants.Route.Configuration) ||
      location.includes(Constants.Route.CustomerLookup) ||
      location.includes(Constants.Route.EmailReportsConglom)
    ) {
      includeCongloms = true;
      this.props.updateIncludeCongloms(true);
    } else {
      this.props.updateIncludeCongloms(false);
    }
    this.props.getClientList(includeCongloms);
  }

  async componentWillUnmount() {
    if (this.previousClientId) {
      await Promise.all([
        this.emailService.leaveGroup(this.previousClientId),
        this.smsService.leaveGroup(this.previousClientId),
        this.processingItemService.leaveGroup(this.previousClientId)
      ]);
    }
  }

  onClientChangeAsync = async (clientId) => {
    trackPromise(this.onClientChange(clientId));
  };

  async onClientChange(clientId) {
    try {
      if (this.previousClientId && this.previousClientId !== clientId) {
        await Promise.all([
          this.emailService.leaveGroup(this.previousClientId),
          this.smsService.leaveGroup(this.previousClientId),
          this.processingItemService.leaveGroup(this.previousClientId)
        ]);
      }
        // Join the new group on each hub.
      await Promise.all([
        this.emailService.joinGroup(clientId),
        this.smsService.joinGroup(clientId),
        this.processingItemService.joinGroup(clientId)
      ]);  
      this.previousClientId = clientId;
    } catch (error) {
      console.error("Error handling SignalR group change:", error);
    }  

    trackPromise(this.props.getClientUserClaims(clientId));
    trackPromise(this.props.GetClient(clientId));
    trackPromise(this.props.getUser(clientId));
    this.props.updateClientID(clientId);
    HelperFunctions.setCookie("brand", clientId, 300);
    HelperFunctions.setCookie("selectedClientId", clientId, 300);
    localStorage.setItem("selectedClientId", clientId);
    const clientItem = this.props.clientList
      ? this.props.clientList.find((element) => element.clientId === clientId)
      : null;
    this.props.insertPortalAccessLog(
      clientId,
      clientItem ? clientItem.clientName : "",
      this.props.router.location ? this.props.router.location.pathname : ClientDropDown.name,
      "Client Selection"
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.clientList.length === 0 && prevProps.clientList.length > 0) {
      throw new Error("Client not found");
    }
    if (this.props.clientList !== prevProps.clientList) {
      if (this.props.clientList && this.props.clientList.length > 0) {
        let selectedClientId = Number(HelperFunctions.getCookie("selectedClientId"));
          //TODO: to be cleaned
          // if (selectedClientId) {
          //   let dafaultClinet = this.props.clientList.find(
          //     (item) => item.clientId == selectedClientId
          //   );
          //   if (dafaultClinet) {
          //     this.setState({ selectedClient: dafaultClinet.clientId });
          //     this.onClientChange(dafaultClinet.clientId);
          //   }
          //   else {
          //     this.setState({
          //       selectedClient: this.props.clientList[0].clientId,
          //     });
          //     this.onClientChange(this.props.clientList[0].clientId);
          //   }
          // } else {
          //   this.setState({ selectedClient: this.props.clientList[0].clientId });
          //   this.onClientChange(this.props.clientList[0].clientId);
          // }
          let defaultClient = this.props.clientList.find(
          (item) => item.clientId === selectedClientId
        );
        if (!defaultClient) {
          defaultClient = this.props.clientList[0];
        }
        if (defaultClient) {
          this.setState({ selectedClient: defaultClient.clientId });
          this.onClientChange(defaultClient.clientId);
        }
      }
    }
  }

  handleChange = (event) => {
    if (event) {
      this.setState({ selectedClient: event.value });
      try{
          this.onClientChangeAsync(event.value).then(() => {
            if (
              window.location.pathname.toLowerCase().includes(Constants.Route.Configuration) ||
              window.location.pathname.toLowerCase().includes(Constants.Route.CustomerLookup) ||
              window.location.pathname.toLowerCase().includes(Constants.Route.FileManagement) ||
              window.location.pathname.toLowerCase().includes(Constants.Route.EmailReportsConglom)
            ) {
              setTimeout(() =>{
                  window.location.reload();
              },2000)
              
            } else {
              this.props.router.navigate("/HomePage");
            }
          });
      }
      catch(e){
        console.log("catch e ", e);
      }
     
    }
  };

  renderDropDown() {
    const options = [];
    this.props.clientList.forEach((item) => {
      options.push({ label: item.clientName, value: item.clientId });
    });
    return options;
  }

  DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <i className="fa fa-search" />
        </components.DropdownIndicator>
      )
    );
  };

    /** render method */
  render() {
    let dropDown = this.renderDropDown();
    return (
      <Select
        id="clients-dropdown"
        classNamePrefix="clients-filter"
        // components={{ DropdownIndicator: this.DropdownIndicator }}
        options={dropDown}
        isSearchable={true}
        value={dropDown.filter(({ value }) => value === this.state.selectedClient)}
        styles={{
          menuPortal: (provided) => ({ ...provided, zIndex: 999999 }),
          menu: (provided) => ({ ...provided, zIndex: 999999 }),
        }}
        placeholder={"Search Clients..."}
        onChange={this.handleChange}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    clientId: state.common.clientId,
    clientList: state.common.clientDropDown,
    clientUserClaims: state.common.clientUserClaims,
  };
}

export default connect(mapStateToProps, {
  updateClientID,
  getClientList,
  updateIncludeCongloms,
  insertPortalAccessLog,
  getClientUserClaims,
  GetClient,
  getUser
})(withRouter(ClientDropDown));
